<template>
    <DModal
        v-model="activity_log_comment"
        :show="showModal"
        :title="__('customers.terminations.terminate_silently_confirm_title')"
        is-confirm
        :is-awaiting-validation="true"
        :show-change-reason-input="true"
        :show-incident-list="true"
        :customer-id="contract?.customer_id ?? 0"
        @setIncident="setIncident"
        @update:show="$emit('update:showModal', $event)"
        @confirm="confirmTerminateSilently"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <p>{{ __('customers.terminations.terminate_silently_confirm_message') }}</p>
            <ul>
                <li>
                    {{ __('customers.terminations.terminate_silently_confirm_message_customer') }}
                </li>
                <li>
                    {{ __('customers.terminations.terminate_silently_confirm_message_product') }}
                </li>
            </ul>
        </DCard>
    </DModal>
</template>

<script>
export default {
    name: 'TerminateSilentlyModal',
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        filters: {
            type: Object,
            default: () => { return {} }
        },
        redirectTo: {
            type: String,
            default: 'contract-list'
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            activity_log_comment: '',
            incident_id: null
        }
    },
    methods: {
        confirmTerminateSilently () {
            this.$inertia.post(this.$route('customers.customers.contracts.silent_termination', {
                customer: this.contract.customer_id,
                contract: this.contract.id,
                activity_log_comment: this.activity_log_comment,
                filters: this.filters,
                incident_id: this.incident_id,
                redirectTo: this.redirectTo
            }), {}, {
                onSuccess: () => {
                    this.$emit('close-modal')
                }
            })
        },
        setIncident (value) {
            this.incident_id = value
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    padding: 25px 20px 10px;
    line-height: 1.5em;
    margin: 0;
    opacity: 0.6;
}
li {
    padding-bottom: 5px;
    margin: 0;
    opacity: 0.6;
}
</style>
